import SvgTextTrace from "./SvgTextTrace";
import getInnerTextDimensions from "./getInnerTextDimensions";
import { getTextWidth } from './PositionalLayout';
import { getTextTranslation } from './FigureText';
import computeCellTextBounds from './PositionEngine';
import parseLatex from './parseLatex';
import { RenderObject } from './BaselineRenderer';

function getTransformAngle({angle,angleDirection}){
  return (({up:-1,down:1})[angleDirection] || -1) * (angle||0);
}

function getTextBounds(text) {
  return computeCellTextBounds({ data: { style: {}, value: text } });
}

function isAngleOrthogonal(angle) {
  angle = Math.abs(angle);
  return angle === 0 || angle === 90;
}

function makeTextMeasurer() {
  // Create an OffscreenCanvas
  const canvas = new OffscreenCanvas(1, 1);
  const ctx = canvas.getContext("2d");
  function getMetrics(spanElement) {
    const style = getComputedStyle(spanElement);
    const font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
    
    const text = spanElement.textContent || "";
    
    ctx.font = font;
    
    // Measure text
    const metrics = ctx.measureText(text);
    debugger;
    return metrics; // .fontBoundingBoxAscent;
  }
  return getMetrics;
}


export default function SvgText({

  gridOrigin,


  div,
  value,
  cell,

  relX,
  rectRelY,
  width,
  height,
}){

  let text = value.value ?? "";

  let divChars = document.querySelectorAll(
    '[id$='+div.id+']'
  )

  let pivotId = 'pivot-point-'+cell.join('-')
  let pivotMarker = document.getElementById(pivotId);
  let pivotBounds = pivotMarker && pivotMarker.getBoundingClientRect() || {};


  let textContainerDiv = document.getElementById('text-container-'+cell.join('-'));
  let textContainerBounds = textContainerDiv?.getBoundingClientRect() || {}


  let textStyle = { 
    fontFamily:'Helvetica',
    fontSize:12,
    ...value.style, 
    fill:value.style.color || 'black',
  }
  let { fontSize } = textStyle;

  let {angle,angleDirection} = textStyle;
  let transformAngle = getTransformAngle({angle,angleDirection});
  let lineHeight = transformAngle ? 1 : 1.5;


  let innerTextBounds;
  let innerHeight;
  let innerWidth;
  let pivotTop = pivotBounds.top;
  let pivotLeft = pivotBounds.left;
  if (!isAngleOrthogonal(transformAngle)){
    let outerHeight = textContainerBounds.height;

    let outerTop = textContainerBounds.top;

    let sin45 = 1 / Math.sqrt(2);

    if( transformAngle < 0 ){
      innerHeight = pivotLeft - textContainerBounds.left;
    }else{
      innerHeight = (pivotTop - outerTop) / sin45;
    }

    innerWidth = outerHeight/sin45 - innerHeight

  }else{
    innerTextBounds = getInnerTextDimensions(textContainerBounds, transformAngle);
    innerHeight = innerTextBounds.innerHeight;
    innerWidth = innerTextBounds.innerWidth;
  }



  let chars = Array.from(divChars).filter(x => x.id.indexOf('char') === 0)
  let firstCharsOfLines = chars.filter(charDiv => charDiv.id.includes('char-0'));

  let lineStrings = value.value.split('\n');


  // my code
  if (value.value === "") { return <></>; }
  let tags = parseLatex(value.value);
  console.log('lat', RenderObject({ text: value.value, tags: tags }));
  let cellBounds = { x: relX, y: rectRelY, height: height, width: width };
  //let textboxBounds = getTextBounds(value.value);

  let pixLineHeight = getTextBounds("m").height;

  const textIsAligned = transformAngle === 0 || transformAngle === 90 || transformAngle === -90;

  let renderedLines = [...div.querySelector('.for-svg-positioning').querySelectorAll('.gridcellTextContainer')];
  if(renderedLines.length === 0) return <> </>;
  let htmlTextContainer = renderedLines[0].parentElement;
  let gridCellContainer = htmlTextContainer.closest('[objecttype="GridCell"]');
  let gridCellBox = gridCellContainer.getBoundingClientRect();
  let htmlTextBox = renderedLines[0].parentElement.getBoundingClientRect();
  let textboxBounds = { width: htmlTextBox.width, height: htmlTextBox.height };


  // Output the offset to apply to point p1 to make it equal to point p2
  function offsetForAlign(p1, p2) {
    return [p2[0] - p1[0], p2[1] - p1[1]];
  }

  // We want to align the computed textbox to the computed cellbox
  if (textIsAligned) {
    const normalizedStyle = {
      verticalAlign: value.style.verticalAlign ?? 'middle',
      textAlign: value.style.textAlign ?? 'center',
    }
    
    if (transformAngle === 0) {
    } else {
      // -90 or 90
      // swap width and height
      let tmp = textboxBounds.width;
      textboxBounds.width = textboxBounds.height;
      textboxBounds.height = tmp;
    }

    // These are in textbox-coordinates, where (0,0) is the top-left of the textbox
    let textAlignY = {
      top: 0,
      middle: textboxBounds.height/2,
      bottom: textboxBounds.height,
    }[normalizedStyle.verticalAlign];
    let textAlignX = {
      left: 0,
      center: textboxBounds.width/2,
      right: textboxBounds.width,
    }[normalizedStyle.textAlign];

    // These are in SVG coordinates
    let alignToY = {
      top: 0,
      middle: cellBounds.height/2,
      bottom: cellBounds.height,
    }[normalizedStyle.verticalAlign] + cellBounds.y;
    let alignToX = {
      left: 0,
      center: cellBounds.width/2,
      right: cellBounds.width,
    }[normalizedStyle.textAlign] + cellBounds.x;

    const [textboxX, textboxY] = offsetForAlign([textAlignX, textAlignY], [alignToX, alignToY]);

    textboxBounds.x = textboxX;
    textboxBounds.y = textboxY;

    let rotPoint = {
      x: textboxBounds.x + textboxBounds.width/2,
      y: textboxBounds.y + textboxBounds.height/2,
    }

    if (transformAngle !== 0) {
      // 90 or -90
      // we have computed the textbox after transform
      // now we want to compute the before-transform textbox,
      // so we can set the attribute properly
      // the before-transform textbox is just the width and height swapped,
      let tmp = textboxBounds.width;
      textboxBounds.width = textboxBounds.height;
      textboxBounds.height = tmp;
      // and the relative x,y to the rotPoint swapped.
      let toCenterX = textboxBounds.x - rotPoint.x;
      let toCenterY = textboxBounds.y - rotPoint.y;
      textboxBounds.x = rotPoint.x + toCenterY;
      textboxBounds.y = rotPoint.y + toCenterX;
    }

    textboxBounds.transform = `rotate(${transformAngle}, ${rotPoint.x}, ${rotPoint.y})`;
  } else {
    // text isn't aligned to 0 or 90 or -90 deg
    // so we ignore the verticalAlign/textAlign properties
    // and instead align it to the middle-top (T) side of the cell

    // we align the left-top (|¯) side
    // these are in textbox coordinates
    let textAlignX = 0;
    let textAlignY = 0;

    // to the top-middle of the cell
    // these are in SVG coordinates
    let alignToX = cellBounds.x + cellBounds.width/2;
    let alignToY = cellBounds.y;

    const [textboxX, textboxY] = offsetForAlign([textAlignX, textAlignY], [alignToX, alignToY]);
    textboxBounds.x = textboxX;
    textboxBounds.y = textboxY;
    let rotPoint = {
      x: textboxBounds.x,
      y: textboxBounds.y + textboxBounds.height/2,
    }
    textboxBounds.transform = `rotate(${transformAngle}, ${rotPoint.x}, ${rotPoint.y})`;
  }

  console.log('$boxes', {htmlTextBox, gridCellBox, cellBounds, textboxBounds, gridCellContainer, htmlTextContainer});
  //textboxBounds.x = htmlTextBox.x - gridCellBox.x + cellBounds.x;
  //textboxBounds.y = htmlTextBox.y - gridCellBox.y + cellBounds.y;

  let measure = makeTextMeasurer();
  
  let htmlSpans = renderedLines.flatMap(lineEl => 
    [...lineEl.querySelectorAll('span')].filter(span => {
      let children = span.childNodes;
      return children.length === 1 && children[0].nodeName === '#text';
    })
  );

  let offsetY = 0;
  if (htmlSpans.length > 0) {
    let firstSpan = htmlSpans[0];
    let m = measure(firstSpan);

    //THIS ?? here is required for Chrome which does'n't support all properties in `measureText()`
    offsetY = (m.fontBoundingBoxAscent ?? 0) - (m.emHeightAscent ?? 0);


    if( isNaN(offsetY) ){
      debugger;
    }
    console.log('$o', offsetY);
  }

  let tspans = htmlSpans.map(span => {
    let rect = span.getBoundingClientRect();
    let metrics = measure(span);
    debugger;
    let relativePos = { x: rect.x - htmlTextBox.x, y: rect.y - htmlTextBox.y };
    let x = textboxBounds.x + relativePos.x;
    let y = textboxBounds.y + relativePos.y + offsetY + (metrics.emHeightAscent ?? 0);
    let spanStyle = getComputedStyle(span);
    let fontSize = spanStyle.fontSize.split('px')[0];
    return <tspan x={x} y={y}
      fontSize={fontSize}
      textDecoration={spanStyle.textDecoration}
    >{span.textContent}</tspan>
  });


  const TRACE = false;
  return <>
    <text style={textStyle} x={textboxBounds.x} y={textboxBounds.y + offsetY} transform={textboxBounds.transform}>{tspans}</text>
    {TRACE && <>
      <rect x={cellBounds.x} y={cellBounds.y} width={cellBounds.width} height={cellBounds.height}
        fill="none"
        stroke="red"
        strokeWidth="2"
      />
      <rect x={textboxBounds.x} y={textboxBounds.y} width={textboxBounds.width} height={textboxBounds.height}
        fill="none"
        stroke="green"
        strokeWidth="2"
      />
    </>}
  </>
}
